import { createFileRoute } from "@tanstack/react-router";

import { PageEditorPage } from "../../../../features/storefront/page-editor";

export const Route = createFileRoute("/_app/settings/pages/$id")({ component: PageEditorRoute });

function PageEditorRoute() {
  const { id } = Route.useParams();
  return <PageEditorPage key={id} id={id} />;
}
